<form class="page-wrapper">
    <!-- ── Zefix full-width row ─────────────────────────────────────────── -->
    <div class="zefix-full-row" *ngIf="showZefixSearch || showImportBanner">
        <zefix-search
            *ngIf="showZefixSearch"
            [isActive]="isZefixActive"
            (companySelected)="onZefixCompanySelected($event)"
            (manualEntry)="onZefixManualEntry()"
        ></zefix-search>

        <div class="zefix-import-banner" *ngIf="showImportBanner">
            <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            >
                <polyline points="20 6 9 17 4 12" />
            </svg>
            <div class="banner-text">
                <strong>{{ zefixImportedData?.name }}</strong>
                {{ 'aumico_zefix_imported_banner' | i18next }}
            </div>
            <span class="banner-sync-time" *ngIf="zefixLastSyncedAt">
                {{ zefixLastSyncedAt | dateLocale : 0 : null : true : true }}
            </span>
            <div class="banner-actions">
                <button class="banner-btn-refresh" type="button" (click)="openRefreshModal()">
                    <svg
                        width="11"
                        height="11"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <polyline points="23 4 23 10 17 10" />
                        <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
                    </svg>
                    {{ 'aumico_zefix_refresh_button' | i18next }}
                </button>
                <button class="banner-btn-new-search" type="button" (click)="onNewSearch()">
                    <svg
                        width="11"
                        height="11"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                    {{ 'aumico_zefix_new_search' | i18next }}
                </button>
            </div>
        </div>
    </div>

    <!-- ── Left Column ────────────────────────────────────────────────────── -->
    <div class="page-col page-col--main">
        <!-- Card: Firmenangaben -->
        <div class="form-card">
            <div class="form-card-header">
                <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                </svg>
                <span class="form-card-title">{{ 'aumico_companies_details_text' | i18next }}</span>
            </div>
            <div class="form-card-body">
                <!-- Status + Logo + Name -->
                <div class="d-flex gap">
                    <div class="logo-wrapper">
                        <img
                            [src]="uploadedLogo ?? defaultUploadImage"
                            class="logo"
                            (click)="showUploadDialog = true"
                        />
                    </div>
                    <div class="company-name-wrapper">
                        <div class="companies-form-separator company-status" *ngIf="!hideStatus">
                            <span hamBadge color="green" *ngIf="active">
                                {{ 'aumico_companies_activate_state' | i18next }}
                            </span>
                            <span hamBadge color="red" *ngIf="!active">
                                {{ 'aumico_companies_inactivate_state' | i18next }}
                            </span>
                        </div>
                        <div class="aum-row aum-row--name-label">
                            <div class="aum-col">
                                <div class="field-label-row">
                                    <label class="zefix-field-label">
                                        {{ 'aumico_companies_form_label_name' | i18next }}
                                        <span class="required-star">*</span>
                                    </label>
                                    <span class="zefix-badge" *ngIf="isZefixField('name')">
                                        {{ 'aumico_zefix_badge' | i18next }}
                                    </span>
                                </div>
                                <input
                                    hamInput
                                    [formControl]="companyFormGroup.controls['name']"
                                    placeholder="{{ 'aumico_companies_form_placeholder_please_enter' | i18next }}"
                                    showRequired="true"
                                    [zefixLocked]="isZefixField('name')"
                                    (zefixModified)="onZefixFieldModified('name')"
                                    [zefixOverridden]="isZefixOverridden('name')"
                                />
                            </div>
                            <div class="aum-col">
                                <div class="field-label-row">
                                    <label class="zefix-field-label">{{
                                        'aumico_companies_form_label_label' | i18next
                                    }}</label>
                                </div>
                                <input
                                    hamInput
                                    [formControl]="companyFormGroup.controls['label']"
                                    placeholder="{{ 'aumico_companies_form_placeholder_please_enter' | i18next }}"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Country + Legal Form -->
                <div class="aum-row">
                    <div class="aum-col">
                        <div class="field-label-row">
                            <label class="zefix-field-label">
                                {{ 'aumico_companies_form_label_country' | i18next }}
                                <span class="required-star">*</span>
                            </label>
                        </div>
                        <input
                            hamSimpleDropDown
                            [options]="countryOptions"
                            [optionKeys]="['name']"
                            returnKey="id"
                            [returnObject]="true"
                            [placeholder]="'aumico_companies_form_placeholder_please_enter' | i18next"
                            [formControl]="companyFormGroup.controls['country']"
                            showRequired="true"
                        />
                        <div
                            *ngIf="showWarningLegalFormNotExist && companyFormGroup.controls['country']?.value"
                            class="warning"
                        >
                            {{ local.aumico_companies_form_country_has_no_legal_form | i18next }}
                        </div>
                    </div>
                    <div class="aum-col">
                        <div class="field-label-row">
                            <label class="zefix-field-label">
                                {{ 'aumico_companies_form_label_legal_form' | i18next }}
                                <span class="required-star">*</span>
                            </label>
                            <span class="zefix-badge" *ngIf="isZefixField('legalform')">
                                {{ 'aumico_zefix_badge' | i18next }}
                            </span>
                        </div>
                        <input
                            hamSimpleDropDown
                            [options]="legalFormsOptions"
                            [optionKeys]="['name']"
                            returnKey="id"
                            [returnObject]="true"
                            [placeholder]="'aumico_companies_form_placeholder_please_enter' | i18next"
                            [formControl]="companyFormGroup.controls['legalform']"
                            showRequired="true"
                            [zefixTracked]="isZefixField('legalform')"
                            (zefixModified)="onZefixFieldModified('legalform')"
                            [zefixOverridden]="isZefixOverridden('legalform')"
                        />
                    </div>
                </div>

                <!-- Assignee + Clerk + Workflow -->
                <div class="aum-row">
                    <div class="aum-col usersearch">
                        <input
                            hamSearchDropDown
                            [options]="organizationUsers"
                            [optionKeys]="['name']"
                            returnKey="id"
                            [label]="'aumico_companies_form_assigned_users' | i18next"
                            [returnObject]="true"
                            [placeholder]="'aumico_core_search' | i18next"
                            [formControl]="companyFormGroup.controls['assignee']"
                            [multiple]="false"
                            [hideDisplaySelection]="true"
                            class="searchuserinput"
                            #searchUserInput
                            showRequired="true"
                        />
                        <div class="meta-card" *ngIf="companyFormGroup.controls['assignee'].value">
                            <company-editor-meta-info
                                [meta]="{
                                    createdByName: currentSelectedAssigneeName,
                                    createdAt: companyFormGroup.controls['assignedOn']?.value
                                }"
                                (close)="companyFormGroup.controls['assignee'].setValue(null)"
                            ></company-editor-meta-info>
                        </div>
                    </div>
                    <div class="aum-col usersearch">
                        <input
                            hamSearchDropDown
                            [options]="organizationUsers"
                            [optionKeys]="['name']"
                            returnKey="id"
                            [label]="'aumico_companies_list_filter_clerk' | i18next"
                            [returnObject]="true"
                            [placeholder]="'aumico_core_search' | i18next"
                            [formControl]="companyFormGroup.controls['clerk']"
                            [multiple]="false"
                            [hideDisplaySelection]="true"
                            class="searchuserinput"
                            #searchUserInput
                            showRequired="true"
                        />
                        <div class="meta-card" *ngIf="companyFormGroup.controls['clerk'].value">
                            <company-editor-meta-info
                                [meta]="{
                                    createdByName: currentSelectedClerkName,
                                    createdAt: companyFormGroup.controls['assignedOnClerk']?.value
                                }"
                                (close)="companyFormGroup.controls['clerk'].setValue(null)"
                            ></company-editor-meta-info>
                        </div>
                    </div>
                    <div class="aum-col" *ngIf="organizationHasCpmmActive">
                        <input
                            *ngIf="organizationHasCpmmActive && organizationHasMandateAndTaskManagementEnabled"
                            hamSimpleDropDown
                            [options]="workflowOptions"
                            [optionKeys]="['name']"
                            returnKey="id"
                            [returnObject]="true"
                            [label]="'aumico_companies_form_closing_workflow' | i18next"
                            [placeholder]="local.aumico_companies_form_placeholder_please_enter | i18next"
                            [formControl]="companyFormGroup.controls['workflow']"
                            showRequired="true"
                        />
                    </div>
                </div>
            </div>
        </div>

        <!-- Card: Adresse -->
        <div class="form-card">
            <div class="form-card-header">
                <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                </svg>
                <span class="form-card-title">{{ 'aumico_companies_form_label_address' | i18next }}</span>
            </div>
            <div class="form-card-body">
                <div class="aum-row">
                    <div class="aum-col">
                        <div class="field-label-row">
                            <label class="zefix-field-label">{{
                                'aumico_companies_form_label_street_and_number' | i18next
                            }}</label>
                            <span class="zefix-badge" *ngIf="isZefixField('street')">{{
                                'aumico_zefix_badge' | i18next
                            }}</span>
                        </div>
                        <input
                            hamInput
                            [formControl]="companyFormGroup.controls['street']"
                            placeholder="{{ 'aumico_companies_form_placeholder_please_enter' | i18next }}"
                            [zefixLocked]="isZefixField('street')"
                            (zefixModified)="onZefixFieldModified('street')"
                            [zefixOverridden]="isZefixOverridden('street')"
                        />
                    </div>
                    <div class="aum-col">
                        <div class="field-label-row">
                            <label class="zefix-field-label">{{
                                'aumico_companies_form_label_addition_to_address' | i18next
                            }}</label>
                        </div>
                        <input
                            hamInput
                            [formControl]="companyFormGroup.controls['additionToAddress']"
                            placeholder="{{ 'aumico_companies_form_placeholder_optional' | i18next }}"
                        />
                    </div>
                </div>

                <div class="aum-row">
                    <div class="aum-col">
                        <div class="field-label-row">
                            <label class="zefix-field-label">{{
                                local.aumico_companies_form_label_zip_code | i18next
                            }}</label>
                            <span class="zefix-badge" *ngIf="isZefixField('zip')">{{
                                'aumico_zefix_badge' | i18next
                            }}</span>
                        </div>
                        <input
                            hamInput
                            placeholder="{{ local.aumico_companies_form_placeholder_please_enter | i18next }}"
                            [formControl]="companyFormGroup.controls['zip']"
                            [zefixLocked]="isZefixField('zip')"
                            (zefixModified)="onZefixFieldModified('zip')"
                            [zefixOverridden]="isZefixOverridden('zip')"
                        />
                    </div>
                    <div class="aum-col">
                        <div class="field-label-row">
                            <label class="zefix-field-label">{{
                                local.aumico_companies_form_label_city | i18next
                            }}</label>
                            <span class="zefix-badge" *ngIf="isZefixField('city')">{{
                                'aumico_zefix_badge' | i18next
                            }}</span>
                        </div>
                        <input
                            hamInput
                            placeholder="{{ local.aumico_companies_form_placeholder_please_enter | i18next }}"
                            [formControl]="companyFormGroup.controls['city']"
                            [zefixLocked]="isZefixField('city')"
                            (zefixModified)="onZefixFieldModified('city')"
                            [zefixOverridden]="isZefixOverridden('city')"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ── Right Column ────────────────────────────────────────────────────── -->
    <div class="page-col page-col--side">
        <!-- Card: Kontaktdaten -->
        <div class="form-card">
            <div class="form-card-header">
                <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                </svg>
                <span class="form-card-title">{{
                    local.aumico_companies_form_section_name_contact_details | i18next
                }}</span>
            </div>
            <div class="form-card-body">
                <div class="aum-row">
                    <div class="aum-col">
                        <input
                            hamInput
                            placeholder="{{ local.aumico_companies_form_placeholder_please_enter | i18next }}"
                            [formControl]="companyFormGroup.controls['firstName']"
                            label="{{ local.aumico_companies_form_label_first_name | i18next }}"
                        />
                    </div>
                    <div class="aum-col">
                        <input
                            hamInput
                            placeholder="{{ local.aumico_companies_form_placeholder_please_enter | i18next }}"
                            [formControl]="companyFormGroup.controls['lastName']"
                            label="{{ local.aumico_companies_form_label_last_name | i18next }}"
                        />
                    </div>
                </div>

                <div class="aum-row">
                    <div class="aum-col">
                        <input
                            hamInput
                            placeholder="{{ local.aumico_companies_form_placeholder_please_enter | i18next }}"
                            [formControl]="companyFormGroup.controls['email']"
                            label="{{ local.aumico_companies_form_label_email | i18next }}"
                        />
                    </div>
                    <div class="aum-col">
                        <input
                            hamInput
                            placeholder="{{ local.aumico_companies_form_placeholder_please_enter | i18next }}"
                            [formControl]="companyFormGroup.controls['phone']"
                            label="{{ local.aumico_companies_form_label_phone | i18next }}"
                        />
                    </div>
                </div>
            </div>
        </div>

        <!-- Card: Rechtliche Information -->
        <div class="form-card">
            <div class="form-card-header">
                <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <rect x="3" y="3" width="18" height="18" rx="2" />
                    <line x1="9" y1="3" x2="9" y2="21" />
                </svg>
                <span class="form-card-title">{{
                    local.aumico_companies_form_section_name_legal_information | i18next
                }}</span>
            </div>
            <div class="form-card-body">
                <div class="aum-row">
                    <div class="aum-col">
                        <div class="field-label-row">
                            <label class="zefix-field-label">{{
                                local.aumico_companies_form_label_uid_number | i18next
                            }}</label>
                            <span class="zefix-badge" *ngIf="isZefixField('UID')">{{
                                'aumico_zefix_badge' | i18next
                            }}</span>
                        </div>
                        <input
                            hamInput
                            placeholder="CHE-XXX.XXX.XXX"
                            [formControl]="companyFormGroup.controls['UID']"
                            [zefixLocked]="isZefixField('UID')"
                            (zefixModified)="onZefixFieldModified('UID')"
                            [zefixOverridden]="isZefixOverridden('UID')"
                        />
                    </div>
                    <div class="aum-col">
                        <div class="field-label-row">
                            <label class="zefix-field-label">{{
                                'aumico_companies_form_label_tax_domicile' | i18next
                            }}</label>
                        </div>
                        <input
                            hamInput
                            placeholder="{{ local.aumico_companies_form_placeholder_please_enter | i18next }}"
                            [formControl]="companyFormGroup.controls['taxDomicile']"
                        />
                    </div>
                </div>

                <div class="aum-row">
                    <div class="aum-col">
                        <input
                            hamSimpleDropDown
                            [options]="industryOptions"
                            [optionKeys]="['name']"
                            returnKey="id"
                            [returnObject]="true"
                            [label]="'aumico_companies_form_label_GICSCode' | i18next"
                            [placeholder]="'aumico_companies_form_placeholder_please_enter' | i18next"
                            [formControl]="companyFormGroup.controls['GICSCode']"
                            [multiple]="false"
                        />
                    </div>
                    <div class="aum-col"></div>
                </div>
            </div>
        </div>

        <!-- Card: Funktionalwährung. While creating there is no company id yet, so the consent is
             only remembered here and the page activates right after the company was written. -->
        <div
            class="form-card fx-card"
            [class.fx-card--active]="isFxActive"
            [class.fx-card--celebrate]="fxJustActivated"
        >
            <span class="fx-card__sweep" *ngIf="fxJustActivated" aria-hidden="true"></span>
            <div class="form-card-header">
                <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <polyline points="17 1 21 5 17 9" />
                    <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                    <polyline points="7 23 3 19 7 15" />
                    <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                </svg>
                <span class="form-card-title">{{ 'aumico_companies_fx_section_title' | i18next }}</span>
                <span class="fx-status__badge" *ngIf="isFxActive" hamBadge color="green">
                    {{ 'aumico_companies_fx_active_chip' | i18next }}
                </span>
                <span class="fx-status__badge" *ngIf="isFxPending" hamBadge color="yellow">
                    {{ 'aumico_companies_fx_pending_chip' | i18next }}
                </span>
            </div>
            <div class="form-card-body">
                <ng-container *ngIf="isFxPending">
                    <p class="fx-hint">{{ 'aumico_companies_fx_pending_hint' | i18next }}</p>
                    <div>
                        <ham-button
                            size="sm"
                            type="button"
                            [outline]="true"
                            (buttonClick)="cancelFxPendingActivation()"
                        >
                            {{ 'aumico_companies_fx_pending_cancel' | i18next }}
                        </ham-button>
                    </div>
                </ng-container>

                <ng-container *ngIf="!isFxActive && !isFxPending">
                    <p class="fx-hint">{{ 'aumico_companies_fx_inactive_hint' | i18next }}</p>
                    <div>
                        <ham-button
                            *ngIf="canManageFx"
                            size="sm"
                            type="button"
                            [disabled]="fxBusy"
                            (buttonClick)="openFxConsentModal()"
                        >
                            {{ 'aumico_companies_fx_activate_button' | i18next }}
                        </ham-button>
                    </div>
                    <p class="fx-hint fx-hint--muted" *ngIf="!canManageFx">
                        {{ 'aumico_companies_fx_no_permission_hint' | i18next }}
                    </p>
                </ng-container>

                <ng-container *ngIf="isFxActive">
                    <dl class="fx-facts">
                        <div class="fx-facts__row" *ngIf="fxSettings?.activatedAt">
                            <dt class="fx-facts__label">{{ 'aumico_companies_fx_activated_on' | i18next }}</dt>
                            <dd class="fx-facts__value">{{ fxSettings.activatedAt | date: 'dd.MM.yyyy' }}</dd>
                        </div>
                        <div class="fx-facts__row" *ngIf="fxSettings?.minimumTermEndsAt">
                            <dt class="fx-facts__label">{{ 'aumico_companies_fx_minimum_term_until' | i18next }}</dt>
                            <dd class="fx-facts__value">{{ fxSettings.minimumTermEndsAt | date: 'dd.MM.yyyy' }}</dd>
                        </div>
                    </dl>

                    <!-- Outlined, and worded in full: the page header already carries a red
                         company-level "Deaktivieren". -->
                    <div>
                        <ham-button
                            *ngIf="canManageFx"
                            size="sm"
                            type="button"
                            variant="red"
                            [outline]="true"
                            [disabled]="fxBusy"
                            (buttonClick)="openFxDeactivateModal()"
                        >
                            {{ 'aumico_companies_fx_deactivate_button' | i18next }}
                        </ham-button>
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- REV-22155: Card Verknüpfte Personen — profile only, display only (managed on the person). -->
        <div class="form-card" *ngIf="editMode && linkedPersons.length > 0">
            <div class="form-card-header">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                </svg>
                <span class="form-card-title">{{ 'aumico_companies_form_section_linked_persons' | i18next }}</span>
            </div>
            <div class="form-card-body">
                <div class="linked-person" data-testid="company-linked-person" *ngFor="let person of linkedPersons">
                    <span class="linked-person__avatar">{{ personInitials(person.name) }}</span>
                    <button type="button" class="linked-person__name" (click)="linkedPersonClick.emit(person._id)">
                        {{ person.name }}
                    </button>
                    <span class="linked-person__role">{{ personRoleLabel(person.role) }}</span>
                </div>
            </div>
        </div>

        <!-- REV-22155: Card Tag — same box as the person form. -->
        <div class="form-card">
            <div class="form-card-header">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
                    <line x1="7" y1="7" x2="7.01" y2="7" />
                </svg>
                <span class="form-card-title">{{ 'aumico_tags_box_title' | i18next }}</span>
            </div>
            <div class="form-card-body">
                <aumico-tag-box
                    [tags]="tags"
                    [selectedTagIds]="selectedTagIds"
                    [usage]="tagUsage"
                    [error]="tagError"
                    (selectionChange)="onTagSelectionChange($event)"
                    (create)="tagCreate.emit($event)"
                    (deleteRequest)="tagDeleteRequest.emit($event)"
                    (deleteConfirm)="tagDeleteConfirm.emit($event)"
                    (deleteCancel)="tagDeleteCancel.emit()"
                ></aumico-tag-box>
            </div>
        </div>
    </div>
</form>

<ham-modal
    *ngIf="showFxConsentModal"
    [title]="'aumico_companies_fx_modal_title' | i18next"
    [saveText]="'aumico_companies_fx_modal_confirm' | i18next"
    [cancelText]="'aumico_companies_fx_modal_cancel' | i18next"
    [showCancelButton]="true"
    [disabled]="!fxConsentAccepted || fxBusy"
    (cancel)="cancelFxConsent()"
    (save)="confirmFxConsent()"
>
    <div class="fx-modal">
        <p class="fx-modal__intro">{{ 'aumico_companies_fx_modal_intro' | i18next }}</p>

        <div class="fx-modal__terms">
            <div class="fx-modal__term">
                <span class="fx-modal__term-label">{{ 'aumico_companies_fx_modal_price' | i18next }}</span>
                <span class="fx-modal__term-value"
                    >CHF {{ fxPrice }}.– / {{ 'aumico_companies_fx_modal_per_year' | i18next }}</span
                >
            </div>
            <div class="fx-modal__term">
                <span class="fx-modal__term-label">{{ 'aumico_companies_fx_modal_term' | i18next }}</span>
                <span class="fx-modal__term-value"
                    >{{ fxTermMonths }} {{ 'aumico_companies_fx_modal_months' | i18next }}</span
                >
            </div>
        </div>

        <div
            hamCheckbox
            class="fx-modal__consent"
            [checked]="fxConsentAccepted"
            (change)="fxConsentAccepted = $event.checked"
        >
            {{ 'aumico_companies_fx_modal_consent_checkbox' | i18next }}
        </div>
    </div>
</ham-modal>

<ham-modal
    *ngIf="showFxDeactivateModal"
    [title]="'aumico_companies_fx_deactivate_confirm_title' | i18next"
    [saveText]="'aumico_companies_fx_deactivate_button' | i18next"
    [cancelText]="'aumico_companies_fx_modal_cancel' | i18next"
    [showCancelButton]="true"
    [disabled]="fxBusy"
    (cancel)="showFxDeactivateModal = false"
    (save)="confirmFxDeactivate()"
>
    <p class="fx-modal__intro">{{ 'aumico_companies_fx_deactivate_confirm_body' | i18next }}</p>
</ham-modal>

<!-- ── Zefix Diff / Refresh Modal ────────────────────────────────────────── -->
<ham-modal
    *ngIf="showDiffModal"
    [title]="'aumico_zefix_diff_title' | i18next"
    [saveText]="'aumico_zefix_diff_apply_all' | i18next"
    [cancelText]="'aumico_button_companies_form_cancel' | i18next"
    [showCancelButton]="true"
    [disabled]="diffLoading || diffHasNoChanges"
    (cancel)="closeDiffModal()"
    (save)="applyDiff()"
>
    <div *ngIf="diffLoading" class="diff-loading">
        <span class="spin-ring-lg"></span>
    </div>
    <div class="diff-no-changes" *ngIf="!diffLoading && diffHasNoChanges">
        <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        >
            <polyline points="20 6 9 17 4 12" />
        </svg>
        <span>{{ 'aumico_zefix_diff_no_changes' | i18next }}</span>
    </div>
    <div class="diff-table" *ngIf="!diffLoading && diffFields.length > 0">
        <div class="diff-header">
            <span>{{ 'aumico_zefix_diff_field' | i18next }}</span>
            <span>{{ 'aumico_zefix_diff_current' | i18next }}</span>
            <span>{{ 'aumico_zefix_diff_new' | i18next }}</span>
        </div>
        <div class="diff-row" *ngFor="let diff of diffFields">
            <span class="diff-field-name">{{ diff.labelKey | i18next }}</span>
            <span class="diff-old">{{ diff.currentValue || '—' }}</span>
            <span class="diff-new">{{ diff.newValue }}</span>
        </div>
    </div>
</ham-modal>

<!-- ── Logo Upload Modal ──────────────────────────────────────────────────── -->
<ham-modal
    *ngIf="showUploadDialog"
    [saveText]="'aumico_button_save' | i18next"
    [title]="'aumico_reports_companies_upload_logo' | i18next"
    [cancelText]="'aumico_button_cancel' | i18next"
    [showCancelButton]="true"
    (cancel)="onCancelUpload()"
    (save)="onFileUploaded()"
    [disabled]="fileSizeError"
>
    <upload-modal
        acceptedExtensions=".png"
        [file]="logo"
        [fileMetaData]="fileMetadata"
        (fileUploaded)="newFileUploaded($event)"
        (fileError)="onFileSizeError($event)"
    ></upload-modal>
</ham-modal>

<!-- ── Clerk Change Confirmation ─────────────────────────────────────────── -->
<ham-modal
    *ngIf="openClerkChangeConfirmationDialog"
    (cancel)="closeClerkChangeConfirmationDialog()"
    [saveText]="'aumico_company_assignee_change_confirmation_dialog_save_button' | i18next"
    [size]="'default'"
    [showCancelButton]="true"
    [cancelText]="'aumico_licence_banner_dialog_close_button' | i18next"
    (save)="updateClerk()"
>
    <div class="flex-start task-reassignment">
        <h3>{{ 'aumico_company_assignee_change_confirmation_dialog_title' | i18next }}</h3>
        <span class="description">{{ 'aumico_company_assignee_change_confirmation_dialog_text' | i18next }}</span>
        <label class="option-card" (click)="selectedTaskUpdate = tasksUpdate.UPDATE_TASKS_ASSIGNED_TO_CURRENT">
            <div class="content">
                <div class="title">
                    {{ 'aumico_company_assignee_change_confirmation_update_tasks_assigned_to_current_user' | i18next }}
                </div>
                <div class="description">
                    {{
                        'aumico_company_assignee_change_confirmation_update_tasks_assigned_to_current_user_description_text'
                            | i18next
                    }}
                </div>
            </div>
            <input type="radio" name="task-reassignment" checked />
        </label>
        <label class="option-card" (click)="selectedTaskUpdate = tasksUpdate.UPDATE_ALL_TASKS">
            <div class="content">
                <div class="title">{{ 'aumico_company_assignee_change_confirmation_update_all_tasks' | i18next }}</div>
                <div class="description">
                    {{ 'aumico_company_assignee_change_confirmation_update_all_tasks_description_text' | i18next }}
                </div>
            </div>
            <input type="radio" name="task-reassignment" />
        </label>
    </div>
</ham-modal>

<!-- ── Workflow Change Confirmation ──────────────────────────────────────── -->
<ham-modal
    *ngIf="openWorkFlowChangeConfirmationDialog"
    [size]="'sm'"
    (cancel)="cancelWorkflowChange()"
    [hideFooter]="true"
>
    <div class="flex-center">
        <span class="ham-icon exclamation-wrapper"><i class="exclamation-outline-icon"></i></span>
        <span class="workflow-text1">{{ 'aumico_companies_workflow_change_title' | i18next }}</span>
        <span class="workflow-text2">{{ 'aumico_companies_workflow_change_text' | i18next }}</span>
        <div class="workflow-buttons">
            <span>
                <ham-button
                    class="workflow-cancel-button"
                    size="sm"
                    (buttonClick)="cancelWorkflowChange()"
                    type="submit"
                    variant="transparent"
                    outline="true"
                >
                    {{ 'aumico_companies_workflow_change_cancel' | i18next }}
                </ham-button>
            </span>
            <span>
                <ham-button
                    class="workflow-confirm-button"
                    size="sm"
                    (buttonClick)="confirmWorkflowChange()"
                    type="submit"
                >
                    {{ 'aumico_companies_workflow_change_confirm' | i18next }}
                </ham-button>
            </span>
        </div>
    </div>
</ham-modal>
